import { UsersApi } from '@cmctechnology/phoenix-stockbroking-api-client';
import { createConfig } from '../configuration/configuration';
import { createApiConfig, createAxios, Interceptor } from './axiosFactory';

export const createUsersApi = (interceptor?: Interceptor) => {
  const { apiUrl } = createConfig();
  const usersApi = new UsersApi(createApiConfig(), apiUrl, createAxios(interceptor));

  return usersApi;
};
